import * as React from 'react';

import { QUIZ_LOCK_INVALID_ERROR } from '@showbie-socrative/socrative-utils';

import { DialogProps } from '~shared/components/Dialog';
import { AxiosServerErrorDialog } from '~teacher/components/QuizEditor/ServerErrorDialog/AxiosServerErrorDialog';
import { GenericServerErrorDialog } from '~teacher/components/QuizEditor/ServerErrorDialog/GenericServerErrorDialog';
import { SessionExpiredErrorDialog } from '~teacher/components/QuizEditor/ServerErrorDialog/SessionExpiredErrorDialog';

import { isAxiosError } from '../../../../api/isAxiosError';

export interface ServerErrorDialogProps
  extends Pick<DialogProps, 'open' | 'onClose'> {
  error: unknown;
}

/**
 * This component is designed to handle all type of errors that can occur on the quiz editor
 */
export function ServerErrorDialog({ error, ...props }: ServerErrorDialogProps) {
  if (isAxiosError(error)) {
    // Is it an axios error?
    if (error.response?.data?.code === QUIZ_LOCK_INVALID_ERROR.code) {
      // Is this an error caused by an invalid lock
      return <SessionExpiredErrorDialog onClose={props.onClose} />;
    } else {
      // Just a regular axios error.
      return <AxiosServerErrorDialog error={error} {...props} />;
    }
  } else {
    // Some sort of generic error. (Not Axios related :( )
    return <GenericServerErrorDialog error={error} {...props} />;
  }
}
